module.exports = __webpack_public_path__ + "static/works-gopage-7af677dc04707ab876fc8eb953fcd6b9.jpg";